export default function () {
    return {
        restrict: 'E',
        template: require('./postCodeLookUp.html'),
        scope: {},
        bindToController: {
            postCode: '=',
            addressLine1: '=',
            addressLine2: '=',
            addressLine3: '=',
            buttonClass: '@'
        },
        controller,
        controllerAs: 'postCodeLookUp'
    };
}

function controller(lookUpPostCode) {
    const vm = this;

    vm.buttonClass = vm.buttonClass || 'bttn wide';
    vm.displayDropDown = false;
    vm.addresses = [];
    vm.selectedAddress = null;

    /* --- */

    vm.lookUp = lookUp;
    vm.selectAddress = selectAddress;

    /* --- */

    function lookUp() {
        if (!vm.postCode) {
            return;
        }

        lookUpPostCode(vm.postCode)
        .then(result => {
            vm.addresses = result;

            vm.displayDropDown = true;
            vm.selectedAddress = null;
        });
    }

    function selectAddress() {
        vm.addressLine1 = vm.selectedAddress.addressLine1;
        vm.addressLine2 = vm.selectedAddress.addressLine2;
        vm.addressLine3 = vm.selectedAddress.addressLine3;
        vm.postCode = vm.selectedAddress.postCode;

        vm.displayDropDown = false;
        vm.selectedAddress = null;
    }
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/postCodeLookUp.js